import React, { useContext } from "react";
import { Col } from "react-bootstrap";
import { TiposAtendimentosLista } from "./TiposAtendimentosLista";
import { MarcadoresLista } from "./MarcadoresLista";
import "./index.css";
import { isMobile } from "react-device-detect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { AtendimentoContext } from "../../../contexts/AtendimentoContext";

export function FiltrosLaterais(){
  const { openListaTiposAtendimentos, setOpenListaTiposAtendimentos } = useContext(AtendimentoContext);

  const mobileComponent = (
    <Col sm={2} className={`filtros-laterais-section mobile-version ${openListaTiposAtendimentos ? 'show' : ''}`}>
      <div className="filtros-laterais-header-section">
        <span>Lista Tipos Atendimento</span>
        <FontAwesomeIcon 
          className="btn-retornar"
          icon={faArrowRight} 
          onClick={() => {
            setOpenListaTiposAtendimentos(false)
          }}
        />
      </div>
      <TiposAtendimentosLista/>
      <hr/>
      <MarcadoresLista/>
    </Col>
  )

  const desktopComponent = (
    <Col sm={2} className="filtros-laterais-section pr-0">
      <TiposAtendimentosLista/>
      <hr/>
      <MarcadoresLista/>
    </Col>
  )

  return (
    isMobile ? 
      mobileComponent
    :
      desktopComponent
  )
}
